import script from "./ComboBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ComboBox.vue?vue&type=script&setup=true&lang=js"

import "./ComboBox.vue?vue&type=style&index=0&id=4a65b410&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a65b410"]])

export default __exports__